import { defineComponent as _defineComponent } from 'vue'
import PaymentButton from '../payment-button.vue'
import {ref, computed} from 'vue'
type Props = {
    balance: number
    disabled: boolean
}
type Emits = {
    (e: 'submitPayout', amount: number): void
    (e: 'previous'): void
    (e: 'amountChange', amount: number): void
    (e: 'disableButton'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'withdrawForm',
  props: {
    balance: null,
    disabled: { type: Boolean }
  },
  emits: ["submitPayout", "previous", "amountChange", "disableButton"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'submitPayout', amount: number): void
    (e: 'previous'): void
    (e: 'amountChange', amount: number): void
    (e: 'disableButton'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    balance: number
    disabled: boolean
}

const amount = ref(0);

const remainder = computed(() => (props.balance || 0) - (amount.value || 0));
// TODO: Eventually also check the selected account
// const submitEnabled = computed(() => amount.value > 0);
const submitEnabled = computed(()=> props.balance > 0);

const previous = () =>{
    emit('previous')
}
const submitPayout = () => {
    // emit('submitPayout', amount.value);
    emit('submitPayout', props.balance)
}
const amountChange = () => {
    emit('amountChange', amount.value);
}

function submitWithdraw() {
    submitPayout();
}


const __returned__ = { amount, props, remainder, submitEnabled, emit, previous, submitPayout, amountChange, submitWithdraw, PaymentButton, ref, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})